var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPAddAadhar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.25C16.989 0.322935 11.2447 2.74322 6.99396 6.99396C2.74322 11.2447 0.322935 16.989 0.25 23C0.322935 29.011 2.74322 34.7553 6.99396 39.006C11.2447 43.2568 16.989 45.6771 23 45.75C29.011 45.6771 34.7553 43.2568 39.006 39.006C43.2568 34.7553 45.6771 29.011 45.75 23C45.6771 16.989 43.2568 11.2447 39.006 6.99396C34.7553 2.74322 29.011 0.322935 23 0.25ZM36 24.625H24.625V36H21.375V24.625H10V21.375H21.375V10H24.625V21.375H36V24.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPAddAadhar);
export default __webpack_public_path__ + "static/media/p_add_aadhar.ceec8ea866853d9cd666291c47cc94d0.svg";
export { ForwardRef as ReactComponent };